
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
import { useRouter } from "next/router";
import HomeApp from "home/components/HomeApp";
import AdminApp from "admin/components/AdminApp";

import "../css/main.css";
import { DocsApp } from "admin/components/DocsApp";
import { ServiceApp } from "../service/components/ServiceApp";
import { RequestsApp } from "requests/components/RequestsApp";
import { ShareApp } from "share/components/ShareApp";

function Ejsingholm({ Component, pageProps }) {
  const { pathname } = useRouter();

  if (Component.root) return <Component {...pageProps} />;

  const App = determineApp(pathname);

  return <App Component={Component} pageProps={pageProps} />;
}

const __Page_Next_Translate__ = Ejsingholm;

const determineApp = (pathname) => {
  if (pathname.startsWith("/next/admin")) return AdminApp;
  if (pathname.startsWith("/docs")) return DocsApp;
  if (pathname.startsWith("/service")) return ServiceApp;
  if (pathname.startsWith("/requests")) return RequestsApp;
  if (pathname.startsWith("/partners")) return RequestsApp;
  if (pathname.startsWith("/share")) return ShareApp;
  return HomeApp;
};


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  